import { normalizeFontFamilyName } from './normalize-font-family-name';
import { ProviderTypes } from './types';
var allFonts = [
    buildWebSafeFont("Helvetica" /* FontNames.Helvetica */),
    buildWebSafeFont("Arial" /* FontNames.Arial */),
    buildWebSafeFont("Verdana" /* FontNames.Verdana */),
    buildWebSafeFont("Trebuchet ms" /* FontNames.TrebuchetMs */),
    buildWebSafeFont("Georgia" /* FontNames.Georgia */),
    buildWebSafeFont("Times new roman" /* FontNames.TimeNewRoman */),
    buildWebSafeFont("Courier" /* FontNames.Courier */),
    buildWebSafeFont("Comic sans" /* FontNames.ComicSans */),
    buildWebSafeFont("Tahoma" /* FontNames.Tahoma */),
    {
        cdnName: '',
        characterSets: [],
        displayName: 'Courier New',
        fallbacks: [],
        fontFamily: 'courier new',
        provider: ProviderTypes.system,
    },
    {
        cdnName: 'Niconne',
        characterSets: ['latin', 'latin-ext'],
        displayName: 'Niconne Regular',
        fallbacks: ['niconne', "Georgia" /* FontNames.Georgia */],
        fontFamily: 'niconne-regular',
        provider: ProviderTypes.google,
    },
    {
        cdnName: '',
        characterSets: ['latin'],
        displayName: 'DIN Next LT Pro Light',
        fallbacks: [],
        fontFamily: 'dinnextlight',
        provider: ProviderTypes.system,
    },
    {
        cdnName: '',
        characterSets: [
            'latin',
            'latin-ext',
            'greek',
            'greek-ext',
            'cyrillic',
            'cyrillic-ext',
        ],
        displayName: 'Bodoni Poster',
        fallbacks: [],
        fontFamily: 'bodonistd poster',
        provider: ProviderTypes.system,
    },
    {
        cdnName: '',
        characterSets: ['latin'],
        displayName: 'ITC Arecibo',
        fallbacks: [],
        fontFamily: 'areciboitcstd',
        provider: ProviderTypes.system,
    },
    {
        cdnName: '',
        characterSets: ['latin'],
        displayName: 'Amatic SC',
        fallbacks: ["Comic sans" /* FontNames.ComicSans */],
        fontFamily: 'amaticsc-regular',
        provider: ProviderTypes.system,
    },
    {
        cdnName: 'Roboto',
        characterSets: ['latin', 'latin-ext'],
        displayName: 'Roboto',
        fallbacks: ["Arial" /* FontNames.Arial */],
        fontFamily: 'roboto',
        provider: ProviderTypes.system,
    },
    {
        cdnName: 'PlayfairDisplay',
        characterSets: ['latin', 'latin-ext', 'cyrillic'],
        displayName: 'Playfair Display',
        fallbacks: ["Times new roman" /* FontNames.TimeNewRoman */],
        fontFamily: 'playfair display',
        provider: ProviderTypes.google,
    },
    {
        cdnName: 'PlayfairDisplaySC',
        characterSets: ['latin', 'latin-ext', 'cyrillic'],
        displayName: 'Playfair Display SC',
        fallbacks: ["Times new roman" /* FontNames.TimeNewRoman */],
        fontFamily: 'playfair display sc',
        provider: ProviderTypes.google,
    },
    {
        cdnName: 'Montserrat',
        characterSets: ['latin', 'latin-ext', 'cyrillic'],
        displayName: 'Montserrat',
        fallbacks: ["Helvetica" /* FontNames.Helvetica */],
        fontFamily: 'montserrat',
        provider: ProviderTypes.google,
    },
    {
        cdnName: 'Raleway',
        characterSets: ['latin', 'latin-ext', 'cyrillic'],
        displayName: 'Raleway',
        fallbacks: ["Verdana" /* FontNames.Verdana */],
        fontFamily: 'raleway',
        provider: ProviderTypes.google,
    },
    {
        cdnName: 'Pompiere',
        characterSets: [
            'latin',
            'latin-ext',
            'cyrillic',
            'cyrillic-ext',
            'greek',
            'greek-ext',
            'vietnamese',
        ],
        displayName: 'Pompiere',
        fallbacks: ["Trebuchet ms" /* FontNames.TrebuchetMs */],
        fontFamily: 'pompiere',
        provider: ProviderTypes.google,
    },
    {
        cdnName: 'AmaticSC',
        characterSets: ['latin', 'latin-ext'],
        displayName: 'Amatic SC',
        fallbacks: [],
        fontFamily: 'amatic sc',
        provider: ProviderTypes.google,
    },
    {
        cdnName: 'FjallaOne',
        characterSets: ['latin', 'latin-ext'],
        displayName: 'Fjalla One',
        fallbacks: ["Tahoma" /* FontNames.Tahoma */],
        fontFamily: 'fjalla one',
        provider: ProviderTypes.google,
    },
    {
        cdnName: 'Lobster',
        characterSets: ['latin', 'latin-ext', 'vietnamese', 'cyrillic'],
        displayName: 'Lobster',
        fallbacks: ["Georgia" /* FontNames.Georgia */],
        fontFamily: 'lobster',
        provider: ProviderTypes.google,
    },
    {
        cdnName: 'Cookie',
        characterSets: ['latin'],
        displayName: 'Cookie',
        fallbacks: ["Comic sans" /* FontNames.ComicSans */],
        fontFamily: 'cookie',
        provider: ProviderTypes.google,
    },
    {
        cdnName: 'Pacifico',
        characterSets: ['latin'],
        displayName: 'Pacifico',
        fallbacks: ["Georgia" /* FontNames.Georgia */],
        fontFamily: 'pacifico',
        provider: ProviderTypes.google,
    },
    {
        cdnName: 'Overlock',
        characterSets: ['latin', 'latin-ext'],
        displayName: 'Overlock',
        fallbacks: ["Tahoma" /* FontNames.Tahoma */],
        fontFamily: 'overlock',
        provider: ProviderTypes.google,
    },
    {
        cdnName: 'DancingScript',
        characterSets: ['latin'],
        displayName: 'Dancing Script',
        fallbacks: ["Times new roman" /* FontNames.TimeNewRoman */],
        fontFamily: 'dancing script',
        provider: ProviderTypes.google,
    },
    {
        cdnName: 'OpenSans',
        characterSets: [
            'latin',
            'latin-ext',
            'greek',
            'greek-ext',
            'vietnamese',
            'cyrillic',
            'cyrillic-ext',
        ],
        displayName: 'Open Sans',
        fallbacks: ["Arial" /* FontNames.Arial */],
        fontFamily: 'open sans',
        provider: ProviderTypes.google,
    },
    {
        cdnName: 'OpenSansCondensed',
        characterSets: [
            'latin',
            'latin-ext',
            'greek',
            'greek-ext',
            'vietnamese',
            'cyrillic',
            'cyrillic-ext',
        ],
        displayName: 'Open Sans Condensed',
        fallbacks: ["Arial" /* FontNames.Arial */],
        fontFamily: 'open sans condensed',
        provider: ProviderTypes.google,
    },
    {
        cdnName: 'Jura',
        characterSets: ['latin', 'latin-ext', 'greek', 'cyrillic', 'cyrillic-ext'],
        displayName: 'Jura',
        fallbacks: ["Verdana" /* FontNames.Verdana */],
        fontFamily: 'jura',
        provider: ProviderTypes.google,
    },
    {
        cdnName: 'TitilliumWeb',
        characterSets: ['latin', 'latin-ext'],
        displayName: 'Titillium Web',
        fallbacks: ["Tahoma" /* FontNames.Tahoma */],
        fontFamily: 'titillium web',
        provider: ProviderTypes.google,
    },
    {
        cdnName: 'DroidSerif',
        characterSets: ['latin'],
        displayName: 'Droid Serif',
        fallbacks: [],
        fontFamily: 'droid serif',
        provider: ProviderTypes.google,
    },
    {
        cdnName: 'NixieOne',
        characterSets: ['latin'],
        displayName: 'Nixie One',
        fallbacks: ["Courier" /* FontNames.Courier */],
        fontFamily: 'nixie one',
        provider: ProviderTypes.google,
    },
    {
        cdnName: 'FrederickatheGreat',
        characterSets: ['latin'],
        displayName: 'Fredericka The Great',
        fallbacks: ["Times new roman" /* FontNames.TimeNewRoman */],
        fontFamily: 'fredericka the great',
        provider: ProviderTypes.google,
    },
    {
        cdnName: 'Lato',
        characterSets: ['latin', 'latin-ext'],
        displayName: 'Lato',
        fallbacks: ["Tahoma" /* FontNames.Tahoma */],
        fontFamily: 'Lato',
        provider: ProviderTypes.google,
    },
    {
        cdnName: 'Rochester',
        characterSets: ['latin'],
        displayName: 'Rochester',
        fallbacks: ["Georgia" /* FontNames.Georgia */],
        fontFamily: 'Rochester',
        provider: ProviderTypes.google,
    },
    {
        cdnName: 'Righteous',
        characterSets: ['latin', 'latin-ext'],
        displayName: 'Righteous',
        fallbacks: ["Helvetica" /* FontNames.Helvetica */],
        fontFamily: 'Righteous',
        provider: ProviderTypes.google,
    },
];
function buildWebSafeFont(name, fallbacks) {
    if (fallbacks === void 0) { fallbacks = []; }
    return {
        cdnName: '',
        characterSets: [],
        displayName: name,
        fallbacks: fallbacks || [],
        fontFamily: name.toLowerCase(),
        provider: ProviderTypes.webSafe,
    };
}
var normalizedFonts = allFonts.map(function (_a) {
    var cdnName = _a.cdnName, characterSets = _a.characterSets, displayName = _a.displayName, fallbacks = _a.fallbacks, fontFamily = _a.fontFamily, provider = _a.provider;
    return ({
        cdnName: cdnName,
        cdnSubsets: characterSets.join(','),
        fallbacks: fallbacks.join(','),
        fontFamily: fontFamily,
        normalizedDisplayName: normalizeFontFamilyName(displayName),
        normalizedFontFamily: normalizeFontFamilyName(fontFamily),
        provider: provider,
    });
});
export default normalizedFonts;
//# sourceMappingURL=fonts.js.map